module.exports = "/_next/static/images/download-app-small-089d383ad5a0da9eefacc3b6cecdc7c6.png";